import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1F425C', // Dark blue from login page
      light: '#2c5f7c', // Lighter blue from gradient
      dark: '#1a3850', // Darker blue
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#AC1E15', // Red from login page buttons
      light: '#C5251A',
      dark: '#8B1612', // Darker red for hover states
      contrastText: '#ffffff',
    },
    background: {
      default: '#f8fafc', // Light blue-gray for main app background
      paper: '#ffffff',
    },
    error: {
      main: '#AC1E15', // Use the login page red for errors
      light: '#C5251A',
      dark: '#8B1612',
    },
    warning: {
      main: '#F0CF55', // Gold/yellow accent from login page
      light: '#F3D875',
      dark: '#E6C143',
    },
    success: {
      main: '#0891b2', // Blue-green for success (keeping blue theme)
      light: '#06b6d4',
      dark: '#0e7490',
    },
    info: {
      main: '#1F425C', // Dark blue for info
      light: '#2c5f7c',
      dark: '#1a3850',
    },
    text: {
      primary: '#1F425C', // Dark blue for primary text
      secondary: '#64748b', // Gray for secondary text
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      color: '#1F425C', // Dark blue for headings
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      color: '#1F425C',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      color: '#1F425C',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: '#1F425C',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
      color: '#1F425C',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      color: '#1F425C',
    },
  },
  shape: {
    borderRadius: 8, // Slightly rounded like login page
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff',
            borderRadius: 8,
            '& fieldset': {
              borderColor: '#e5e7eb',
            },
            '&:hover fieldset': {
              borderColor: '#F0CF55', // Gold accent on hover
            },
            '&.Mui-focused fieldset': {
              borderColor: '#AC1E15', // Red when focused
              borderWidth: 2,
            },
          },
          '& .MuiInputLabel-root': {
            color: '#64748b',
            '&.Mui-focused': {
              color: '#AC1E15', // Red when focused
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          padding: '12px 24px',
          borderRadius: 8,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          backgroundColor: '#AC1E15',
          '&:hover': {
            backgroundColor: '#8B1612',
          },
        },
        containedSecondary: {
          backgroundColor: '#1F425C',
          '&:hover': {
            backgroundColor: '#1a3850',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
          borderRadius: 12,
          borderLeft: '4px solid #F0CF55', // Gold accent border
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          background: 'linear-gradient(135deg, #1F425C 0%, #2c5f7c 50%, #3a7ca3 100%)', // Login page gradient
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
        colorWarning: {
          backgroundColor: '#F0CF55',
          color: '#1F425C',
        },
      },
    },
  },
});

export default theme; 